import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { Check } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-white" data-id="element-194">
      <Container data-id="element-195">
        <div className="max-w-5xl mx-auto" data-id="element-196">
          <div className="text-center mb-16" data-id="element-197">
            <h2 className="text-sm font-bold tracking-widest text-gray-400 uppercase mb-4" data-id="element-198">
              Product Introduction
            </h2>
            <h3 className="text-3xl md:text-5xl font-serif text-gray-900 mb-6" data-id="element-199">
              Meet SnoreStop™
            </h3>
            <p className="text-xl text-gray-600 font-light max-w-2xl mx-auto" data-id="element-200">
              A simple overnight mouthpiece designed to support quieter more
              restful sleep.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-201">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-202">
              <img src="https://cdn.magicpatterns.com/uploads/3Z94QSUWhk89UAc16qLvg2/ChatGPT_Image_May_9,_2026,_11_43_53_PM.png" alt="SnoreStop Mouthpiece" className="w-full max-w-md mx-auto" data-id="element-203" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="space-y-8" data-id="element-204">
              <ul className="space-y-4" data-id="element-205">
                {['No tubes.', 'No machines.', 'No loud equipment.', 'No complicated setup.'].map((item, i) => <li key={i} className="flex items-center text-lg text-gray-700" data-id="element-206">
                    <Check className="w-5 h-5 text-green-500 mr-3" data-id="element-207" />
                    {item}
                  </li>)}
              </ul>

              <div className="bg-blue-50 p-6 rounded-2xl" data-id="element-208">
                <p className="text-gray-800 leading-relaxed" data-id="element-209">
                  Just a lightweight adjustable mouthpiece worn before bed in
                  under 30 seconds. SnoreStop™ gently supports the jaw position
                  while sleeping which may help reduce airway narrowing
                  associated with snoring.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </Container>
    </section>;
}